export { COMPANY_NAME, REGISTERED_ADDRESS, JURISDICTION_CITY, CONTACT_EMAIL, CONTACT_PHONE_DISPLAY, CONTACT_PHONE_HREF, GRIEVANCE_OFFICER_NAME } from "./legalContact";

export const EFFECTIVE_DATE = "August 21, 2026";
export const LAST_UPDATED = "August 21, 2026";
